import axios from 'axios';
import { baseUrl } from '../settings';
import authHeader from './auth-header';

const API_URL = baseUrl + '/credit/';

class CreditService {
  getUserCreditDetails(page) {
    return axios.post(API_URL + 'userCreditDetails?page=' + page, null, { headers: authHeader() });
  }

  getUserCreditUsageDetails(page) {
    return axios.post(API_URL + 'userCreditUsageDetails?page=' + page, null, { headers: authHeader() });
  }
}

export default new CreditService();